import Keycloak from 'keycloak-js';


const keycloakConfig = {
    url: 'https://interped.simavi.ro', // Your Keycloak server URL (no /auth path needed)
    realm: 'interPED',                          // Your realm name
    clientId: 'dashboard',                   // Your client ID
    clientSecret: 'your-client-secret'            // Optional: client secret if required
};

console.log('🔧 Keycloak Config:', keycloakConfig);

// Initialize Keycloak instance
const keycloak = new Keycloak(keycloakConfig);

console.log('🔧 Keycloak Instance URL:', keycloak.authServerUrl);
console.log('🔧 Keycloak Realm URL:', keycloak.realmUrl);
console.log('🔧 Keycloak Client ID:', keycloak.clientId);

export default keycloak;